import { Component, EventEmitter, OnInit, Output, LOCALE_ID, Inject } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { Observable } from 'rxjs';
import { Carril, Caseta, Turno } from 'src/app/models';
import { Turnos } from 'src/app/models/dash';
import { CasetaService } from 'src/app/services/caseta.service';
import { CorteService } from 'src/app/services/corte.service';
import { FormatoData, FormatoService } from 'src/app/services/formato.service';
import { TurnoService } from 'src/app/services/turno.service';
import { formatDate } from '@angular/common';
import * as moment from 'moment';
import { selectUser } from 'src/app/state/selectors/user.selectors';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/state/app.state';
import { getTurno } from 'src/app/utils';

@Component({
  selector: 'app-formato-header',
  templateUrl: './formato-header.component.html',
  styleUrls: ['./formato-header.component.scss']
})
export class FormatoHeaderComponent implements OnInit {

  casetas: Caseta[];
  carriles: Carril[];
  turnos: Turnos[];
  cortes: any[];
  tiposReporte: string[] = ['Corte-caja', 'Reporte-incidencias', 'Registro-exentos-residentes', 'Retiros-parciales'];
  id_corte_usuario: number;
  cobrador: string;
  jefeTurno: string;
  tipoFormato: number = null;
  base64Reporte = "";
  showModal = false;
  user: any;

  //into page
  fecha: any;
  cortesUsed: any[];
  corteElegido: any;
  turnoActual: Turno;
  catFormatos:{[key: number]: string} = {
    1: 'corte',
    2: 'incidencia',
    3: 'exento',
    4: 'retiro',
    5: 'fallas',
    6: 'retornos',
  }

  corteForm = new FormGroup({
    caseta: new FormControl('', Validators.required),
    turno: new FormControl('', Validators.required),
    fecha: new FormControl('', Validators.required),
    corte: new FormControl('', Validators.required),
  });

  constructor(
    @Inject(LOCALE_ID) public locale: string,
    private router: Router,
    private toastr: ToastrService,
    private activeRoute: ActivatedRoute,
    private casetaService: CasetaService,
    private turnoService: TurnoService,
    private corteService: CorteService,
    private formatoService: FormatoService,
    private ngxUiLoaderService: NgxUiLoaderService,
    private store: Store<AppState>,

  ) { }

  ngOnInit(): void {
    var turno=1
    var fecha= moment().format("YYYY-MM-DD")//pendiente
    this.turnoActual = getTurno();
    switch(this.turnoActual.id){
      case 1: turno=3; break;
      case 2: turno=1; break;
      case 3: turno=2; break;
    }
    this.ngxUiLoaderService.start()
    this.router.navigate(['/dashboard/formato-resumen']);
    this.corteService.getCasetas().subscribe( casetas => {
      this.casetas = casetas;
    });

    this.turnoService.getTurnos().subscribe(turnos => {
      this.turnos = turnos;
    });

    this.store.select(selectUser).subscribe(user =>{
      this.user = user
    });
    let data = {fecha:fecha,id_jefe_turno: this.user.id}
    this.corteForm = new FormGroup({
      caseta: new FormControl(this.user.caseta_usuario[0].id, Validators.required),
      turno: new FormControl(turno, Validators.required),
      fecha: new FormControl(fecha, Validators.required),
      corte: new FormControl('', Validators.required),
    });

    this.corteService.cortesPorFechaCasetaTurno(this.corteForm.getRawValue()).subscribe(cortes => {
      if (!cortes.length) {
        //this.corteFormReset(1);
        this.ngxUiLoaderService.stop()
        return this.toastr.info(`No existen cortes para esta configuracion`, '', { positionClass: 'toast-bottom-right' })
      }
      this.cortes = cortes;
    });
    this.corteService.getCortesUsedJT(data).subscribe(data => {
      this.cortesUsed = data;
      this.ngxUiLoaderService.stop()
    })


  }

  getCaseta() {
    this.casetaService.getCaseta(this.corteForm.value.caseta).subscribe(caseta => {
      this.carriles = caseta.carriles;
    });
  }

  getFormato(event: any) {
    this.tipoFormato = event.target.value;
  }

  getCorte(event) {
    this.id_corte_usuario = event.target.value;
    let user = this.cortes.find(corte => corte.id === Number(this.id_corte_usuario));
    console.log("user", user)
    this.cobrador = user.usuario.nombre;
    //this.jefeTurno = user.jefeturno;

    //this.routeActive(2);
  }

  routeActive(t: number) {
    if (this.activeRoute.children.length > 0) {
      this.router.navigate(['/dashboard/formato-resumen']);
    }
    //(document.getElementById("formatoResumen") as HTMLSelectElement).selectedIndex = 0;
    this.tipoFormato = null;

    if (t === 1) {
      this.corteForm.controls.corte.reset('');
      this.cortes = [];
      this.cobrador = "";
      this.jefeTurno = "";
    }
  }

  enviarConsulta() {
    console.log(this.corteForm.value);
    if (!this.corteForm.valid || !this.tipoFormato) {
      return this.toastr.info(`Seleccione todos los campos para mostrar la informacion`, '', { positionClass: 'toast-bottom-right' })
    }

    this.formatoService.modificarData = {
      id_corte_usuario: Number(this.corteForm.value.corte),
      tipo: Number(this.tipoFormato),
    };


    let ruta='/dashboard/formato-resumen/' + this.catFormatos[this.tipoFormato]
    console.log("ruta", ruta);

    this.router.navigate([ruta]);

  }

  async imprimirPDF(download) {
    this.ngxUiLoaderService.start();
    let { fecha, turno } = this.corteForm.value;
    let data = {
      "id_corte": this.id_corte_usuario,
      "fecha": fecha,
      "turno": turno,
      "formato": this.tipoFormato,
      "download": download, //bandera para imprimir o visualizar el PDF
    }
    await this.corteService.getDataReporte(data)
      .then((data: any) => {
        if (download) {
          let date = formatDate(new Date(), 'dd-MM-yyyy', this.locale);
          let downloadURL = window.URL.createObjectURL(data);
          let link = document.createElement('a');
          link.href = downloadURL;
          link.download = `${this.tiposReporte[this.tipoFormato - 1]}_${date}.pdf`;
          link.click();
          this.ngxUiLoaderService.stop();
          this.toastr.success('Se ha descargado el documento con éxito', '', { positionClass: 'toast-bottom-right' })
        } else {
          this.base64Reporte = data + '#toolbar=1'; //Eliminar cabecera de iframe
          this.openModal();//abrir el modal
          this.ngxUiLoaderService.stop();
        }
      }).catch((err) => {
        console.log(err);
        this.toastr.error("Por favor inténtalo nuevamente", "Se ha producido un error", { positionClass: 'toast-bottom-right' })
        this.ngxUiLoaderService.stop();
      });
  }

  imprimir() {

  }


  openModal() {
    this.showModal = !this.showModal;
  }


  getCorteUsed(event:any) {
    this.corteElegido = event.target.value

  }

  buscarConsulta() {
    //console.log( this.corteForm.value );
    if (!this.tipoFormato || !this.corteElegido) {
      return this.toastr.info(`Seleccione todos los campos para mostrar la informacion`, '', { positionClass: 'toast-bottom-right' })
    }

    this.formatoService.modificarData = {
      id_corte_usuario: Number(this.corteElegido),
      tipo: Number(this.tipoFormato),
    };
    let ruta='/dashboard/formato-resumen/' + this.catFormatos[this.tipoFormato]
    this.router.navigate([ruta]);

  }
  async imprimirPDFRapida(download) {
    this.ngxUiLoaderService.start();
    let corte = this.cortesUsed.find(corte => corte.id === Number(this.corteElegido));
    //console.log(corte);

    let data = {
      "id_corte": this.corteElegido,
      "fecha": corte.fecha_asignacion,
      "turno": corte.turno.id,
      "formato": this.tipoFormato,
      "download": download, //bandera para imprimir o visualizar el PDF
    }
    await this.corteService.getDataReporte(data)
      .then((data: any) => {
        if (download) {
          let date = formatDate(new Date(), 'dd-MM-yyyy', this.locale);
          let downloadURL = window.URL.createObjectURL(data);
          let link = document.createElement('a');
          link.href = downloadURL;
          link.download = `${this.tiposReporte[this.tipoFormato - 1]}_${date}.pdf`;
          link.click();
          this.ngxUiLoaderService.stop();
          this.toastr.success('Se ha descargado el documento con éxito', '', { positionClass: 'toast-bottom-right' })
        } else {
          this.base64Reporte = data + '#toolbar=1'; //Eliminar cabecera de iframe
          this.openModal();//abrir el modal
          this.ngxUiLoaderService.stop();
        }
      }).catch((err) => {
        console.log(err);
        this.toastr.error("Por favor inténtalo nuevamente", "Se ha producido un error", { positionClass: 'toast-bottom-right' })
        this.ngxUiLoaderService.stop();
      });
  }
  buscarCortes(){
    console.log("form", this.corteForm.value)
    // buscar cortes
    let dataForm = this.corteForm.getRawValue();
    this.corteService.cortesPorFechaCasetaTurno(dataForm).subscribe(cortes => {
      if (!cortes.length) {
        return this.toastr.info(`No existen cortes para esta configuracion`, '', { positionClass: 'toast-bottom-right' })
      }
      this.cortes = cortes;
      let data = {fecha:this.corteForm.value.fecha ,id_jefe_turno: this.user.id}
      this.corteService.getCortesUsedJT(data).subscribe(data => {
        this.cortesUsed = data;
        this.ngxUiLoaderService.stop()
      })
    });
  }
}
